import React, { useState } from "react";
import Chart from "chart.js/auto";
import { Pie } from "react-chartjs-2";
import { IoCopyOutline } from "react-icons/io5";
import { IoIosArrowForward } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";
import { IoFilter } from "react-icons/io5";

const MapMetaOrFeatureDataSimple = ({
  multuGroupSelectedArray,
  mapOverview,
  longstandingGeoJSONRef,
  globalState
}) => {

  const mapMetaData = globalState.mapMetaData;

  let showFilterFeatureDataSimpleModal = globalState.showFilterFeatureDataSimpleModal;
  let setShowFilterFeatureDataSimpleModal = globalState.setShowFilterFeatureDataSimpleModal;

  console.log(mapMetaData)

  const sectionLabels = {
    shortname: "Feature Name"
  };

  const formatLabel = (key) =>
    key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  const formatValue = (value, key) => {
    if (value === null || value === undefined) return "—";

    if (key === "created" || key === "modified" || key === "deleted") {
      return value ? new Date(value).toLocaleString() : "—";
    }

    if (Array.isArray(value)) {
      return value.length ? value.join(", ") : "None";
    }

    if (typeof value === "boolean") {
      return value ? "Yes" : "No";
    }

    if (key === "size_approx") {
      return `${(value / 1024 / 1024).toFixed(2)} MB`;
    }

    return String(value);
  };

  const greySections = new Set([
    "external_ids"
  ]);

  const alwaysExpandedSections = new Set([
    "shortname",
    "external_ids",
    "_rlm_sl_rentinfo"
  ]);

  const [expandedSections, setExpandedSections] = useState(
    new Set(alwaysExpandedSections)
  );

  const renderByDisplayHint = (key, value) => {
    const meta =
      mapMetaData?.define_feature_data_simple?.[key];

    const hint = meta?.display_hint;

    if (value === null || value === undefined) {
      return <span>—</span>;
    }

    const formatChartLabel = (key) =>
      key
        .replace(/^_rlm_[^_]+_/, "")
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());

    const formatExternalIdLabel = (key) => {
      const labels = {
        searchlight_property_ref: "Property Reference",
        title_no: "Title Number",
        searchlight_property_code: "Property Code",
        searchlight_tenancy_code: "Tenancy Code",
        inspire_id: "INSPIRE ID",
        searchlight_property_id: "Searchlight Property ID"
      };

      return labels[key] ?? formatLabel(key);
    };

    const renderObjectData = (
      value,
      labelFormatter = formatLabel,
      copyable = false
    ) => {
      if (!value || typeof value !== "object") {
        return "—";
      }

      const copyToClipboard = async (text) => {
        try {
          await navigator.clipboard.writeText(
            String(text)
          );
        } catch (err) {
          console.error(
            "Failed to copy:",
            err
          );
        }
      };

      return (
        <div
          style={{
            display: "grid",
            gap: 4
          }}
        >
          {Object.entries(value)
            .filter(
              ([k]) =>
                k !== "searchlight_property_ref"
            )
            .map(([k, v]) => {
              const isPropertyCode =
                k ===
                "searchlight_property_code";

              return (
                <div
                  key={k}
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "160px 1fr auto",
                    gap: 8,
                    fontSize: "10px",
                    textAlign: "left",
                    alignItems: "center"
                  }}
                >
                  <strong
                    style={{
                      color: "#aaa"
                    }}
                  >
                    {labelFormatter(k)}
                  </strong>

                  <strong
                    style={{
                      textAlign: "left",
                      fontSize: "10px",
                      fontWeight: "bold",
                      color:
                        isPropertyCode
                          ? "#1976d2"
                          : "#000",
                      backgroundColor:
                        isPropertyCode
                          ? "#eaf3ff"
                          : undefined,
                      padding:
                        isPropertyCode
                          ? "2px 6px"
                          : undefined,
                      borderRadius:
                        isPropertyCode
                          ? "4px"
                          : undefined,
                      display:
                        "inline-block",
                      width: "fit-content"
                    }}
                  >
                    {formatValue(v, k)}
                  </strong>

                  {copyable && (
                    <button
                      onClick={() =>
                        copyToClipboard(v)
                      }
                      style={{
                        fontSize: "12px",
                        padding:
                          "2px 6px",
                        cursor: "pointer",
                        textAlign: "right",
                        marginRight: "10px"
                      }}
                    >
                      <IoCopyOutline />
                    </button>
                  )}
                </div>
              );
            })}
        </div>
      );
    };

    /*
     * PIE CHART
     *
     * display_hint:
     *
     * chartdata_pie
     * chartdata_pie:£
     * chartdata_pie:%
     */
    if (
      typeof hint === "string" &&
      hint.startsWith("chartdata_pie")
    ) {
      if (
        !value ||
        typeof value !== "object" ||
        Array.isArray(value)
      ) {
        return formatValue(value, key);
      }

      const unit =
        hint.split(":")[1] ?? "";

      const entries = Object.entries(value);

      return (
        <div
          style={{
            width: "100%",
            maxWidth: 400,
            height: 150
          }}
        >
          <Pie
            data={{
              labels: entries.map(
                ([k]) =>
                  formatChartLabel(k)
              ),
              datasets: [
                {
                  data: entries.map(
                    ([, v]) =>
                      Number(v)
                  ),
                  radius: "60%"
                }
              ]
            }}
            options={{
              responsive: true,
              maintainAspectRatio: false,

              plugins: {
                legend: {
                  position: "left",
                  align: "start",

                  labels: {
                    font: {
                      size: 9
                    },
                    boxWidth: 10,
                    padding: 6,
                    textAlign:
                      "left"
                  }
                },

                tooltip: {
                  titleFont: {
                    size: 9
                  },

                  bodyFont: {
                    size: 9
                  },

                  callbacks: {
                    label: (
                      context
                    ) => {
                      const chartValue =
                        Number(
                          context.raw
                        ).toLocaleString(
                          undefined,
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }
                        );

                      return `${context.label}: ${unit}${chartValue}`;
                    }
                  }
                }
              }
            }}
          />
        </div>
      );
    }

    /*
     * KEY/VALUE OBJECT
     *
     * display_hint:
     *
     * keypair_list
     */
    if (hint === "keypair_list") {
      if (
        !value ||
        typeof value !== "object" ||
        Array.isArray(value)
      ) {
        return formatValue(value, key);
      }

      return (
        <div
          style={{
            display: "grid",
            gap: 2
          }}
        >
          {Object.entries(value).map(
            ([k, v]) => (
              <div
                key={k}
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "150px 1fr",
                  fontSize: "10px",
                  gap: 8
                }}
              >
                <strong
                  style={{
                    color: "#aaa"
                  }}
                >
                  {
                    mapMetaData
                      ?.define_feature_data_simple
                      ?.[k]?.name ??
                    formatLabel(k)
                  }
                </strong>

                <strong
                  style={{
                    textAlign: "left",
                    fontSize: "10px"
                  }}
                >
                  {formatValue(
                    v,
                    k
                  )}
                </strong>
              </div>
            )
          )}
        </div>
      );
    }

    /*
     * TABLE
     *
     * display_hint:
     *
     * tabledata
     */
    if (hint === "tabledata") {
      if (
        !value?.headers ||
        !value?.rows
      ) {
        return "—";
      }

      const columns = value.headers;

      const rows = value.rows.map(
        (row) =>
          Object.fromEntries(
            columns.map(
              (column, index) => [
                column,
                row[index]
              ]
            )
          )
      );

      return (
        <table
          style={{
            width: "100%",
            borderCollapse:
              "collapse",
            fontSize: 11
          }}
        >
          <thead>
            <tr>
              {columns.map(
                (column) => (
                  <th
                    key={column}
                    style={{
                      textAlign:
                        "left",
                      padding: 4,
                      color:
                        "#aaa",
                      fontWeight:
                        "bold"
                    }}
                  >
                    {column}
                  </th>
                )
              )}
            </tr>
          </thead>

          <tbody>
            {rows.map(
              (row, index) => (
                <tr key={index}>
                  {columns.map(
                    (column) => (
                      <td
                        key={
                          column
                        }
                        style={{
                          padding: 4,
                          color:
                            "#000",
                          fontWeight:
                            "bold"
                        }}
                      >
                        {formatValue(
                          row[
                          column
                          ],
                          column
                        )}
                      </td>
                    )
                  )}
                </tr>
              )
            )}
          </tbody>
        </table>
      );
    }

    /*
     * SPECIAL OBJECTS
     */
    if (key === "external_ids") {
      return renderObjectData(
        value,
        formatExternalIdLabel,
        true
      );
    }

    if (
      // key === "feature_data_standard" ||
      key ===
      "feature_data_standard_calculated"
    ) {
      return renderObjectData(value);
    }

    /*
     * DEFAULT
     *
     * If no display_hint is supplied,
     * display the value normally.
     */
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value)
    ) {
      return (
        <pre
          style={{
            whiteSpace: "pre-wrap",
            margin: 0
          }}
        >
          {JSON.stringify(
            value,
            null,
            2
          )}
        </pre>
      );
    }

    return formatValue(value, key);
  };

  const renderData = (data, isMapMeta = false) => (
    <div
      style={{
        fontSize: "12px",
        lineHeight: "1.5"
      }}
    >

      <button
        style={{
          backgroundColor: '#fff',
          border: 'solid #29645D 1px',
          color: '#29645D',
          paddingTop: '5px',
          paddingBottom: '5px',
          width: '55px',
          borderRadius: '3px',
          fontSize: '10px',
          float: 'right',
          marginRight: '10px'
        }}
        onClick={() => setShowFilterFeatureDataSimpleModal(true)}
      >
        <IoFilter />
      </button>


      {Object.entries(data)
        .filter(([key]) => {
          // These are structural sections and are
          // not controlled by feature_data_simple metadata.
          if (
            key === "shortname" ||
            key === "external_ids"
            // key === "feature_data_standard"
          ) {
            return true;
          }

          const meta =
            mapMetaData
              ?.define_feature_data_simple
            ?.[key];

          // If this is a feature_data_simple property,
          // respect display_order.
          if (meta) {
            return meta.display_order !== -1;
          }

          // Unknown properties remain visible.
          return true;
        })
        .map(([key, value]) => {

          const isGrey = greySections.has(key);
          const isExpanded = isMapMeta || expandedSections.has(key);
          const canCollapse =
            !isMapMeta && !alwaysExpandedSections.has(key);

          return (
            <div
              key={key}
              style={{
                paddingTop: "9px",
                paddingBottom: "9px",
                paddingLeft: "10px",
                backgroundColor: isGrey ? "#F2F1F6" : undefined,
              }}
            >
              <div
                onClick={() => {
                  if (!canCollapse) return;

                  setExpandedSections(prev => {
                    const next = new Set(prev);

                    if (next.has(key)) {
                      next.delete(key);
                    } else {
                      next.add(key);
                    }

                    return next;
                  });
                }}
                style={{
                  fontWeight: "bold",
                  marginBottom: isExpanded ? "6px" : 0,
                  paddingBottom: "2px",
                  cursor: canCollapse ? "pointer" : "default",
                  color: isGrey ? "#000" : undefined,
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >

                {sectionLabels[key] ??
                  mapMetaData?.define_feature_data_simple?.[key]?.name ??
                  formatLabel(key)}

                {canCollapse && (
                  <span
                    style={{
                      fontSize: "10px",
                      width: 10,
                      marginLeft: "auto",
                      display: "flex",
                      alignItems: "center",
                      paddingRight: '10px'
                    }}
                  >
                    {isExpanded ? <IoIosArrowDown /> : <IoIosArrowForward />}
                  </span>
                )}

              </div>

              {isExpanded && (
                <div
                  style={{
                    whiteSpace: "pre-wrap",
                    wordBreak: "break-word",
                    color: isGrey ? "#000" : undefined,
                  }}
                >
                  {renderByDisplayHint(key, value)}
                </div>
              )}
            </div>
          );
        })}
    </div>
  );

  if (multuGroupSelectedArray.length === 0) {

    if (!mapOverview) return null;

    const {
      title,
      id,
      feature_count,
      size_approx,
      public: isPublic,
      owner,
      created,
      modified,
      deleted,
      realms
    } = mapOverview;

    return renderData(
      {
        title,
        id,
        feature_count,
        size_approx,
        public: isPublic,
        owner,
        created,
        modified,
        deleted,
        realms
      },
      true
    );
  }

  const feature = longstandingGeoJSONRef.current?.features?.find(
    (f) => f.skylark_id === multuGroupSelectedArray[0]
  );

  if (!feature) return null;

  const {
    shortname,
    ...restFeatureDataSimple
  } = feature.feature_data_simple || {};

  return renderData({
    shortname,
    external_ids: feature.external_ids,
    ...restFeatureDataSimple,
    // feature_data_standard: feature.feature_data_standard
  }, false);
};

export default MapMetaOrFeatureDataSimple;